import React from 'react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  dark?: boolean;
};
export function SectionCTA({
  label,
  dark = false
}: SectionCTAProps) {
  return <div className="mt-10 md:mt-12" data-id="element-56" data-mp="1ld3b6w7lc0yq">
      <CTAButton label={label} sublabel="One-time payment · Just $27" data-id="element-57" data-mp="1lc1ti8w2kg81" />
      <p className={`mt-4 text-center text-xs font-semibold ${dark ? 'text-white/70' : 'text-navy/60'}`} data-id="element-58" data-mp="1qb4xdq0bcgef">
        Instant Digital Access · Secure Checkout · 7-Day Guarantee
      </p>
    </div>;
}